import { Card, CardContent, Typography } from "@mui/material";
import GroupVideoBg from "../../../assets/Group_video_bg.svg";
import { ReactComponent as GroupBottomDesign } from "../../../assets/Group_video_card_bottom_design.svg";

interface GroupVideoContainerProps {
  groupTitle: string;
  locked?: boolean;
  onClick: () => void;
}

export const GroupVideoContainer = (props: GroupVideoContainerProps) => {
  let { groupTitle, onClick, locked = false } = props;
  return (
    <Card
      tabIndex={0}
      sx={{
        margin: "0px 14px",

        minWidth: "276px",
        maxWidth: "276px",
        minHeight: "276px",
        maxHeight: "296px",
        border: "none",
        backgroundImage: `url(${GroupVideoBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        padding: "2rem 2rem 2rem 2rem",
        position: "relative",

        ...(locked && { filter: "grayscale(1)", opacity: "0.7" }),
        ...(!locked && {
          cursor: "pointer",
          transitionProperty:
            "transform, color, border-color, background-color, height, width",
          transitionDuration: "150ms",
          transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
          "&:hover": {
            transform: "scale(1.02)",
          },
        }),
      }}
      onClick={locked ? undefined : onClick}>
      <CardContent sx={{ padding: "0px" }}>
        <Typography
          component="span"
          variant="h4"
          sx={{ color: "#ffffff", fontWeight: "bold", marginBottom: "8px" }}>
          {groupTitle}
        </Typography>
      </CardContent>
      <GroupBottomDesign
        style={{
          position: "absolute",
          top: "165px",
          left: "163px",
          bottom: "24px",
          right: "24px",
          paddingRight: "24px",
        }}
      />
    </Card>
  );
};
